export default {
  to: 'À :',
};

